import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../components/core/services/base-api.service';
import { TServiceResult } from '../../../data-access/models/base/t-service-resutl';
import { IReceipt } from '../../../data-access/models/receipt.interface';
import { GET_DETAIL_TRANSACTION } from '../../../data-access/constants/api';

@Injectable({
  providedIn: 'root',
})
export class ReceiptService {
  constructor(private baseApiService: BaseApiService) {}

  getReceiptData(uniqueId: string): Observable<TServiceResult<IReceipt>> {
    const params = new HttpParams();
    return this.baseApiService.get(GET_DETAIL_TRANSACTION + `?transactionId=${uniqueId}`, params);
  }
}
